import React, { useState, useEffect } from "react";
import "./usertable.css";
import CompanyDashboard from "../../companies/CompanyDashboard";
import { Table, Dropdown, Menu, message, Spin } from "antd";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import AddUserModal from "../../users page/user add agent modal/UserAddAgentModal";
import ViewUserModal from "../../users page/userviewmodal/UserViewModal";
import EditUserModal from "../../users page/usereditmodal/UserEditModal";
import UserDeleteModal from "../../users page/userdeletemodal/UserDeleteModal";
import Instance from "../../../AxiosConfig";

const UserTable = () => {
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null); // 👈 For edit/view/delete tracking

  // ✅ Modal open/close handlers
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleModalClick = ({ key }, record) => {
    setSelectedUser(record); // store selected user

    if (key === "view") setShowViewModal(true);
    else if (key === "edit") setShowEditModal(true);
    else if (key === "delete") setShowDelete(true);
  };

  // ✅ Action menu (passed record to click handler)
  const menu = (record) => (
    <Menu onClick={(info) => handleModalClick(info, record)} className="custom-dropdown-menu">
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );

  // ✅ Columns
  const columns = [
    {
      title: "S.No",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "userEmail",
      key: "userEmail",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text) => text?.toUpperCase(),
    },
    {
      title: "Phone Number",
      dataIndex: "userPhoneNumber",
      key: "userPhoneNumber",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown overlay={menu(record)} trigger={["click"]} placement="bottomRight">
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  // ✅ Fetch users from API
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await Instance.get("/users/");
      if (response.status === 200 || response.status === 201) {
        setUsers(response.data.users || []);
      } else {
        message.warning("No users found.");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Failed to load users. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Delete user by ID
  const handleDeleteUser = async () => {
    if (!selectedUser) return;

    try {
      setLoading(true);
      const response = await Instance.delete(`/users/${selectedUser._id}`);
      if (response.status === 200 || response.status === 201) {
        message.success("User deleted successfully.");
        setUsers((prev) => prev.filter((user) => user.id !== selectedUser.id));
        setShowDelete(false);
        fetchUsers();
      } else {
        message.error("Failed to delete user.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      message.error("Error deleting user. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Edit user (from modal)
 

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      {/* <CompanyDashboard /> */}
      <div className="users-page mt-5">
        <div className="users-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Users List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
              <button className="surve-export-btn" onClick={handleShow}>
                <FaPlus /> Add New Users
              </button>
            </div>
          </div>

          <div className="mt-4">
            {loading ? (
              <div className="text-center my-5">
                <Spin size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={users.map((u, i) => ({ ...u, key: i }))}
                pagination={{
                  pageSize: 5,
                  total: users.length,
                  className: "custom-pagination",
                }}
                scroll={{ x: "max-content" }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Add Modal */}
      <AddUserModal show={showModal} handleClose={handleClose} fetchUsers={fetchUsers}/>

      {/* View Modal */}
      <ViewUserModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        user={selectedUser}
      />

      {/* Edit Modal */}
      <EditUserModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={selectedUser}
        fetchUsers={fetchUsers}
      />

      {/* Delete Modal */}
      <UserDeleteModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        onDelete={handleDeleteUser} // ✅ Actual delete call
        user={selectedUser}
      />
    </div>
  );
};

export default UserTable;
